import { Component, OnDestroy, ViewEncapsulation, input, inject, DOCUMENT, computed, signal } from '@angular/core';
import { Router, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';

import { Spinkit } from './spinkits';
import { LoaderService } from '../../service/loader.service';

@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss', './spinkit-css/sk-line-material.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SpinnerComponent implements OnDestroy {
  private router = inject(Router);
  private document = inject<Document>(DOCUMENT);
  private loaderService = inject(LoaderService);

  Spinkit = Spinkit;
  backgroundColor = input('#2689E2');
  spinner = input(Spinkit.skLine);

  private routeLoading = signal(true);

  readonly isSpinnerVisible = computed(() => this.routeLoading() || this.loaderService.isLoading());

  constructor() {
    this.router.events.subscribe(
      (event) => {
        if (event instanceof NavigationStart) {
          this.routeLoading.set(true);
        } else if (
          event instanceof NavigationEnd ||
          event instanceof NavigationCancel ||
          event instanceof NavigationError
        ) {
          this.routeLoading.set(false);
        }
      },
      () => this.routeLoading.set(false)
    );
  }

  ngOnDestroy(): void {
    this.routeLoading.set(false);
  }
}
